<script lang="ts" setup>

import { SurveyQuestionType } from '../enums';
import { QuestionModel } from '../types';

import { reactive } from 'vue';
import Comment from './Comment.vue';
import Location from './Location.vue';
import SingleText from './SingleText.vue';
import EmailAddress from './EmailAddress.vue';

const props = defineProps<{
  question: QuestionModel;
  isChildQuestion?: boolean;
  multiQuestion?: boolean;
}>();

const emit = defineEmits(['answerChanged']);

const data = reactive({
  model: props.question,
  answer: null,
  isChildQuestion: props.isChildQuestion,
});

const onChildAnswerChanged = (childAnswer: any) => {
  emit('answerChanged', childAnswer);
};
</script>
<template>
  <div
    class="text-left w-full"
    :class="data.isChildQuestion ? 'mb-8' : 'mb-16'"
    v-if="data.model"
    :id="data.model.id"
  >
    <p class="mb-2 font-bold whitespace-pre-line">
      {{ data.model.questionText }}
      <span v-if="data.model.mandatory && !data.isChildQuestion" class="text-red-500">*</span>
    </p>
    <p class="mb-4">{{ data.model.helperText }}</p>

    <div v-if="data.model.childQuestions && data.model.childQuestions.length" class="mt-8">
      <template v-for="(question, index) in data.model.childQuestions" :key="index">
        <Comment
          v-if="question.questionType === SurveyQuestionType.Comment"
          :is-child-question="true"
          :question="question"
          :multi-question="true"
          :id="question.id"
          @answer-changed="onChildAnswerChanged"
        />
        <SingleText
          v-if="question.questionType === SurveyQuestionType.SingleText"
          :is-child-question="true"
          :question="question"
          :multi-question="true"
          :id="question.id"
          @answer-changed="onChildAnswerChanged"
        />
        <EmailAddress
          v-if="question.questionType === SurveyQuestionType.EmailAddress"
          :is-child-question="true"
          :question="question"
          :multi-question="true"
          :id="question.id"
          @answer-changed="onChildAnswerChanged"
        />
        <Location
          v-if="question.questionType === SurveyQuestionType.Location"
          :is-child-question="true"
          :question="question"
          :multi-question="true"
          :id="question.id"
          @answer-changed="onChildAnswerChanged"
        />
      </template>
    </div>
  </div>
</template>
